import { z } from 'zod';
import { UUIDSchema } from '../domain/models';

export const callStatus = [
  'pending',
  'in-processing',
  'success',
  'failed',
] as const;
export const CallStatusSchema = z.enum(callStatus);
export type CallStatus = z.infer<typeof CallStatusSchema>;

export const PatientCallSchema = z.object({
  patientId: UUIDSchema,
  name: z.string(),
  practitionerName: z.string(),
  practitionerId: UUIDSchema,
  status: CallStatusSchema,
  callBackTime: z.number().optional(),
});

export const WorkloadSchema = z.object({
  low: z.number(),
  medium: z.number(),
  high: z.number(),
});

export const CallOverviewBarSchema = z.object({
  callsCompleted: z.number(),
  callBacks: z.number(),
  toCall: z.number(),
  workload: WorkloadSchema,
});

export type PatientCall = z.infer<typeof PatientCallSchema>;
export type CallOverviewBar = z.infer<typeof CallOverviewBarSchema>;
